import { Text } from '@chakra-ui/react'
import React from 'react'
import { useInteractiveTableHeaderCellStyles } from 'hooks/useInteractiveTableHeaderCellStyles'

type InteractiveMobileHeaderCellProps = Omit<React.ComponentProps<typeof Text>, 'sx'>

export const InteractiveMobileHeaderCell = ({
  children,
  onClick,
  ...props
}: InteractiveMobileHeaderCellProps) => {
  const styles = useInteractiveTableHeaderCellStyles()

  return (
    <Text
      w="fit-content"
      sx={styles}
      onClick={(event) => {
        event.stopPropagation()
        onClick?.(event)
      }}
      {...props}
    >
      {children}
    </Text>
  )
}
